import React from 'react';
import { PlayList } from './PlayList.jsx';

export const PlayListToggle = ({playlistIsOpen, onPlaylistToggle, playlist, playlistPosition, onTrackClick, audioPlayerIsLoading}) => {
    return (
        <div className={'playlist-toggle' + (playlistIsOpen ? ' open' : '')} onClick={onPlaylistToggle}>
            {playlistIsOpen &&
            <>
                <div className="playlist-icon-open"></div>
                <PlayList playlist={playlist} playlistIsOpen={playlistIsOpen} playlistPosition={playlistPosition} onTrackClick={onTrackClick} audioPlayerIsLoading={audioPlayerIsLoading}></PlayList>
            </>
            }
            {!playlistIsOpen &&
                <div className="playlist-icon-closed"></div>
            }
        </div>
    );
}